<script>
  import { onMount } from 'svelte';
  import { privacyStore, privacyAccepted } from './stores/privacy.js';
  
  // Local state for analytics consent (before submitting)
  let analyticsChoice = {
    privacyAccepted: true, // Privacy policy is required
    analyticsAccepted: true
  };
  
  onMount(() => {
    // Initialize privacy settings from localStorage
    privacyStore.initialize();
  });

  function acceptAll() {
    privacyStore.acceptAll();
  }
  
  function acceptSelected() {
    privacyStore.acceptCustom(analyticsChoice);
  }
</script>

{#if !$privacyAccepted}
  <div class="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg p-6 max-w-xl w-full max-h-[90vh] overflow-y-auto">
      <h2 class="text-xl font-bold mb-4">Политика за поверителност</h2>
      
      <div class="prose prose-sm">
        <p class="mb-4">
          Уважаеми клиенти,
        </p>
        
        <p class="mb-4">
          Вашата поверителност е важна за нас. Искаме да ви информираме как използваме вашите лични данни:
        </p>

        <ul class="list-disc pl-5 mb-4">
          <li>Събираме лични данни (адрес, телефон) само когато правите поръчка</li>
          <li>Данните се използват единствено за обработка и доставка на вашата поръчка</li>
          <li>Информацията се изпраща по имейл до собственика на магазина за изпълнение на поръчката</li>
          <li>Не съхраняваме данните ви за други цели</li>
          <li>Не споделяме вашите данни с трети страни</li>
        </ul>
        
        <h3 class="text-lg font-semibold mt-6 mb-2">Анализ на потребителското поведение</h3>
        
        <p class="mb-4">
          <strong>Google Analytics:</strong> Използваме Google Analytics, за да анализираме как посетителите използват нашия сайт. Тази услуга събира информация анонимно, като броя на посетителите, откъде идват и кои страници посещават.
        </p>
      </div>
      
      <div class="mt-4 border-t pt-4">
        <div class="space-y-2">
          <div class="flex items-center">
            <input 
              type="checkbox" 
              id="privacy" 
              checked 
              disabled 
              class="mr-2 h-4 w-4" 
            />
            <label for="privacy" class="text-sm">Политика за поверителност (задължително)</label>
          </div>
          
          <div class="flex items-center">
            <input 
              type="checkbox" 
              id="analytics" 
              bind:checked={analyticsChoice.analyticsAccepted} 
              class="mr-2 h-4 w-4" 
          />
            <label for="analytics" class="text-sm">Анализ на потребителското поведение (Google Analytics)</label>
          </div>
        </div>
        
        <div class="mt-6 flex justify-end space-x-3">
          <button
            class="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
            on:click={acceptSelected}
          >
            Запази избраното
          </button>
          <button
            class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            on:click={acceptAll}
          >
            Приемам всички
          </button>
        </div>
      </div>
    </div>
  </div>
{/if} 